import { ResourceType } from "@core/shared/types";

export function useResourceIconStyling() {
  const getResourceIconStyle = (type: ResourceType) => {
    switch (type) {
      case ResourceType.Pdf:
        return "text-orange-600 dark:text-orange-400";
      case ResourceType.Docx:
        return "text-indigo-600 dark:text-indigo-400";
      case ResourceType.Xlsx:
        return "text-emerald-600 dark:text-emerald-400";
      case ResourceType.Pptx:
        return "text-orange-600 dark:text-orange-400";
      case ResourceType.Image:
        return "text-green-600 dark:text-green-400";
      case ResourceType.Video:
        return "text-red-600 dark:text-red-400";
      case ResourceType.Audio:
        return "text-purple-600 dark:text-purple-400";
      case ResourceType.Youtube:
        return "text-red-600 dark:text-red-400";
      case ResourceType.Url:
        return "text-cyan-600 dark:text-cyan-400";
      case ResourceType.Assessment:
        return "text-green-600 dark:text-green-400";
      default:
        return "text-gray-600 dark:text-gray-300";
    }
  };

  return {
    getResourceIconStyle,
  };
}
